import React from "react"
import AskQuestionHeader from "src/components/ask-questions-header"
import ChatSection from "src/components/chat-section"
import useIsLoggedIn from "src/utils/use-is-logged-in"

/**
 * @param props {{
 *  scState?:scState
 * }}
 */

export default function AskQuestion({scState}) {
  const { isLoggedIn, userInfo } = useIsLoggedIn()

  return (
    <>
      {isLoggedIn ? (
        <div
          css={`
            padding: 35px;
            background: #f6f6fa;
            min-height: 100vh;
          `}
        >
          <div>
            <AskQuestionHeader />
          </div>
          <hr
            css={`
              margin-top: 15px;
              border: 1px solid #eaeaf2;
            `}
          />
          <div
            css={`
              margin-top: 25px;
              margin-bottom: 100px;
              clear: both;
            `}
          >
            <ChatSection scState={scState}/>
          </div>
        </div>
      ) : (
        <div
          css={`
            padding: 35px;
            background: #f6f6fa;
            min-height: 100vh;
          `}
        >
          <h2 css="color: red;">Access denied!</h2>
        </div>
      )}
    </>
  )
}
